export enum AccessControlsMethodCheckEnum {
  AND = "AND",
  OR = "OR",
}
